import Input from '../../common/Input';

const items = [
  { key: 'bed', label: 'Krevet' },
  { key: 'wardrobe', label: 'Orman' },
  { key: 'table', label: 'Sto' },
  { key: 'boxes', label: 'Kutije' },
];

export default function Step3_Inventory({ register, watch }) {
  return (
    <section>
      <h2>3. Inventar</h2>
      {items.map((it) => (
        <div key={it.key} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <label><input type="checkbox" {...register(`inventory.${it.key}.selected`)} /> {it.label}</label>
          <Input type="number" min={0} style={{ width: 100 }} {...register(`inventory.${it.key}.qty`, { valueAsNumber: true })} />
        </div>
      ))}
      <Input label="Napomene" as="textarea" rows={4} {...register('notes')} />
    </section>
  );
}
